<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item label="证件名称">
        <el-input v-model="name" clearable placeholder="请输入证件名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="warning" @click="add">新增证件</el-button>
      </el-form-item>
    </el-form>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    >
      <template #img={row}>
        <el-button type="text" :disabled="!row.attchmentUrl" @click="seeImg(row)">证件查看</el-button>
      </template>
      <template #operate={row}>
        <el-button @click="editData(row)" type="text" size="small">编辑</el-button>
        <el-button @click="deleteData(row)" type="text" size="small">删除</el-button>
      </template>
    </table-list>
    <!-- 预览 -->
    <el-image-viewer v-if="showImg" :url-list="urlList" :on-close="colseImg" class="img-viewer-row"/>
    <!-- 新增 -->
    <add-maintain ref="addMaintain" @addSuccess="query"/>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import addMaintain from './addMaintain.vue'
import { query, deletePaper } from '@/api/compPaper'
export default {
  data () {
    return {
      name: '',
      loading: false,
      showImg: false,
      urlList: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      columnDefs: [
        { label: '证件名称', prop: 'paperName' },
        { label: '证件类型', prop: 'paperType' },
        { label: '录入时间', prop: 'modifiedTime' },
        { label: '附件查看', prop: 'img' },
        { label: '操作', prop: 'operate' }
      ],
      tableData: []
    }
  },
  components: {
    TableList,
    ElImageViewer,
    addMaintain
  },
  filters: {
    getFileName (row) {
      let format = row.attchmentUrl.split('.')
      return `${row.paperName}.${format[1]}`
    }
  },
  methods: {
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      query({
        pageNum: this.page,
        pageSize: this.pageSize,
        paperName: this.name
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    add () {
      this.$refs.addMaintain.showDialog()
    },
    seeImg (row) {
      if (row.attchmentType === 'PDF') {
        this.$message.warning('PDF预览请在编辑页面查看！')
        return
      }
      this.showImg = true
      this.urlList = []
      row.attchmentUrl.split(',').forEach(item => {
        this.urlList.push(`${location.origin}${process.env.VUE_APP_BASE_API}/minio/getImage?fileName=${item}`)
      });
    },
    editData (row) {
      this.$refs.addMaintain.showDialog('edit', row)
    },
    colseImg () {
      this.showImg = false
      this.urlList = []
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    deleteData (row) {
      this.$confirm('此操作将删除该证件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        console.log(row)
        deletePaper({
          id: row.id
        }).then(res => {
          const { code } = res
          this.query()
          if (code !== 0) return
          this.$message.success('删除成功！')
        })
      })
    }
  },
  mounted () {
    this.query()
  }
}
</script>

<style lang="scss" scoped>
.img-viewer-row {
  height: 100vh;
  // 防止上传照片高度宽度过大
  /deep/ .el-image-viewer__img{
    max-height: 80vh;
    max-width: 80vw;
  }
}
</style>
